<template>
  <div>
    <div
      v-if="nickname"
    >
      <div class="pa-2">
        <!-- <span class="grey--text">收件人：</span>{{ jyWarehouses[0].formatAddr.name }}<v-btn
          small
          flat
          icon
          color="info"
          class="mx-0"
          @click="copyText(jyWarehouses[0].formatAddr.name)"
        >
          <i class="iconfont iconfuzhi"/>
        </v-btn><br> -->
      </div>
      <v-layout
        wrap
        class="pb-2"
      >
        <v-flex
          v-for="item in jyWarehouses"
          :key="item.addrid"
          :xs6="jyWarehouses.length>1"
          class="pa-2"
        >
          <div class="elevation-2 ">
            <template v-if="!viewAddrid">
              <h4 class="pa-2 text-xs-center">
                {{ item.addrid | whsNameFull }}
                <span style="margin: 0 -5px;">
                  <Tooltips>
                    <WhsText :addrid="item.addrid " />
                  </Tooltips>
                </span>
              </h4>
              <v-divider />
            </template>
            <div
              v-if="item.isInvalid !== '0'"
              outline
              class="red--text py-2 title"
            >
              該倉庫已停用
            </div>
            <div class="px-2 pt-2 caption orange--text">
              保護個資：<span class="mr-3">{{ $store.state.userData.cellphone }}</span>
              加密為：<span>{{ $store.state.userData.cellphone36 }}</span><Tooltips>需跟暱稱一併填寫為收件人</Tooltips>
            </div>
            <v-layout
              align-center
              style="height: 40px;"
              class="px-2 ma-0"
            >
              <div v-if="item.addrid === '1024'">
                <SrIcon
                  transport="air"
                  class="mr-1"
                />
                <SrIcon
                  transport="air"
                  srType="twt"
                  class="mr-1"
                />
              <!-- <span class="ml-1">可使用空運、海快</span> -->
              </div>
              <SrIcon
                v-if="item.addrid === '1591'"
                transport="air"
                class="mr-1"
              />
              <SrIcon
                transport="se"
                class="mr-1"
              />
              <div v-if="item.addrid === '2769' || item.addrid === '1596'">
                <SrIcon transport="sea" />
              </div>
              <!-- <div class="pa-2">
              {{ item.label }}
            </div>
            <div v-if="item.addrid === '1024'">
              <SrIcon transport="air"/>
              <SrIcon
                transport="air"
                srType="twt"/>
              <SrIcon transport="se"/>
            </div>
            <div v-if="item.addrid === '1210'">
              <SrIcon transport="se"/>
            </div>
            <div v-if="item.addrid === '1050'">
              <SrIcon transport="se"/>
            </div> -->
              <v-spacer />
              <template v-if="isShowAddr">
                <span class="grey--text caption">
                  範例：
                </span>
                <v-btn
                  fab
                  depressed
                  color="#f63b00"
                  class="white--text mr-1"
                  style="width:25px;height:25px;"
                  @click="whsItem=item;showAddrExampleTaobaoDialog = true"
                >
                  <i
                    class="iconfont icontaobao"
                    style="font-size: 16px;line-height: 18px;"
                  />
                </v-btn>

                <v-btn
                  fab
                  depressed
                  color="#f75900"
                  class="white--text"
                  style="width:25px;height:25px;"
                  @click="whsItem=item;showAddrExample1688Dialog = true"
                >
                  <i
                    class="iconfont iconalibaba"
                    style="font-size: 20px;line-height: 18px;"
                  />
                </v-btn>
              </template>
            </v-layout>
            <div
              v-if="isShowAddr"
              class="grey lighten-4 pa-2"
            >
              <span class="grey--text">收件人：</span> {{ item.formatAddr.name }}<v-btn
                small
                flat
                icon
                color="info"
                class="ma-0"
                @click="copyText(item.formatAddr.name)"
              >
                <i class="iconfont iconfuzhi" />
              </v-btn><br>
              <span class="grey--text">電話：</span> {{ item.formatAddr.phone }}<v-btn
                small
                flat
                icon
                color="info"
                class="ma-0"
                @click="copyText(item.formatAddr.phone)"
              >
                <i class="iconfont iconfuzhi" />
              </v-btn><br>
              <span class="grey--text">郵編：</span> {{ item.formatAddr.postcode }}<v-btn
                small
                flat
                icon
                color="info"
                class="ma-0"
                @click="copyText(item.formatAddr.postcode)"
              >
                <i class="iconfont iconfuzhi" />
              </v-btn><br>
              <v-layout class="ma-0">
                <div
                  style="word-break: keep-all;"
                  class="grey--text"
                >
                  地址：
                </div>
                <v-flex class="pa-0">
                  {{ item.formatAddr.addr }}<v-btn
                    small
                    flat
                    icon
                    color="info"
                    class="ma-0"
                    @click="copyText(item.formatAddr.addr)"
                  >
                    <i class="iconfont iconfuzhi" />
                  </v-btn>
                </v-flex>
              </v-layout>
            </div>
            <div
              v-else
              class="pa-4"
            >
              新用戶須先體驗過一次空運或是海快才能解鎖海運家具倉地址。
            </div>
          </div>
        </v-flex>
      </v-layout>

      <div
        v-if="isShowAddr"
        style="margin:auto;"
        class="pa-2"
      >
        <AddToTaobao
          :whsItem="jyWarehouses[0]"
        />
      </div>
    </div>
    <v-card
      v-if="!nickname"
      flat
    >
      <v-card-text>
        <h4 class="red--text">
          請輸入2-5位中文暱稱作為轉運倉的收件人名
        </h4>
        <v-form
          ref="form"
        >
          <v-text-field
            v-model="nicknameInputVaue"
            :rules="[$store.state.validationRules.required, $store.state.validationRules.nickname]"
            label="暱稱"
            required
            class="my-2"
          />

          <v-btn
            :loading="loading"
            :disabled="loading"
            block
            color="info"
            @click="saveNickname"
          >
            送出
          </v-btn>
        </v-form>
      </v-card-text>
    </v-card>

    <AddrExampleTaobaoDialog
      v-model="showAddrExampleTaobaoDialog"
      :whsItem="whsItem"
    />

    <AddrExample1688Dialog
      v-model="showAddrExample1688Dialog"
      :whsItem="whsItem"
    />
  </div>
</template>

<script>
import ShippingRate from './ShippingRate'
import AddToTaobao from '../address/AddToTaobao'
import { copyText } from '@g/utils'
import AddrExampleTaobaoDialog from './AddrExampleTaobaoDialog'
import AddrExample1688Dialog from './AddrExample1688Dialog'

export default {
  components: {
    ShippingRate,
    AddToTaobao,
    AddrExampleTaobaoDialog,
    AddrExample1688Dialog,
  },
  props: {
    hideShippintRate: Boolean,
    viewAddrid: String,
  },
  data () {
    return {
      tabIndex: '',
      realnameInputVaue: '',
      nicknameInputVaue: '',
      agree: false,
      loading: false,
      showAddrExampleTaobaoDialog: false,
      showAddrExample1688Dialog: false,
      whsItem: null,
    }
  },
  computed: {
    jyWarehouses: function () {
      return this.$store.state.jyWarehouses.filter(whs => {
        if (this.viewAddrid) {
          return whs.addrid === this.viewAddrid
        }
        if (whs.addrid === '1769') {
          return false
        }
        if (whs.addrid === '2591') {
          return false
        }
        return true
      })
      // return this.$store.state.jyWarehouses
    },
    realname () {
      return this.$store.state.userData.realname
    },
    nickname () {
      // return ''
      return this.$store.state.userData.nickname
    },
    user () {
      return this.$store.state.userData
    },
    isShowAddr () {
      if (!this.user.hasJyorder && this.viewAddrid === '1769') {
        return false
      }
      return true
    },
  },
  watch: {
  },
  mounted () {
    if (this.$store.state.userData.defaultWhsAddrid) {
      this.initTabIndex()
    }
  },
  methods: {
    initTabIndex () {
      const index = this.jyWarehouses.findIndex(item => item.addrid === this.$store.state.userData.defaultWhsAddrid)
      if (index !== -1) {
        this.tabIndex = index
      }
    },
    openTab (tab) {
      this.$store.commit('parcel/setShowShippingRate', true)
      this.$store.commit('parcel/setShippingRateCurrentTab', tab)
    },
    async saveRealname () {
      if (!this.$refs.form.validate()) {
        return
      }
      try {
        this.loading = true
        const res = await this.$store.dispatch('user/updateRealname', {
          newRealname: this.realnameInputVaue
        })
        if (!res.data.error) {
          await this.$store.dispatch('init')
        }
      } finally {
        this.loading = false
      }
    },
    copyText (text) {
      copyText(text)
      this.$snackbar('複製成功')
    },
    async saveNickname () {
      if (!this.$refs.form.validate()) {
        return
      }
      try {
        this.loading = true
        if (!await this.$confirm('暱稱設定後將無法修改', {
          buttonTrueText: '確認',
          buttonFalseText: '取消',
        })) return
        const res = await this.$store.dispatch('user/updateNickname', {
          newNickname: this.nicknameInputVaue
        })
        if (!res.data.error) {
          this.$store.state.userData.nickname = res.data.model.nickname
        }
      } finally {
        this.loading = false
      }
    },
  }
}
</script>

<style>

</style>
